import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  version: "1.1",
  id: "__Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  width: "45px",
  height: "45px",
  viewBox: "0 0 45 45",
  style: {"enable-background":"new 0 0 45 45"},
  "xml:space": "preserve"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent("style"), { type: "text/css" }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode(".__st0{fill:none}.__st1{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10}.__st2{fill:#231F20}.__st3{fill:#121319}")
      ])),
      _: 1
    })),
    _cache[1] || (_cache[1] = _createStaticVNode("<g id=\"__Group_1673_1_\" transform=\"translate(-1.499 -2597)\"><g id=\"__Group_1614_1_\" transform=\"translate(-9.157 2260.614)\"><path id=\"__Path_866_1_\" class=\"__st0\" d=\"M37.56,348.07l-4.4-1.45l-4.4,1.45v4.45l8.79,0.02L37.56,348.07z\"></path><g id=\"__Group_1613_1_\"><path id=\"__Path_867_1_\" d=\"M28.76,352.53v-4.45l4.4-1.45l4.4,1.45v4.48h1l0.88,1.62v-6.78c0-0.41-0.26-0.77-0.64-0.89l-4.7-1.55\r\n\t\t\t\tv-3.06h-1.88v3.06l-4.69,1.55c-0.39,0.13-0.65,0.49-0.65,0.89v6.81l0.94-1.68L28.76,352.53z\"></path><path d=\"M39.75,375.89h-2v-16.5l-1.29-2.68h-6.6l-1.29,2.68v16.5h-2v-16.73c0-0.15,0.03-0.3,0.1-0.43l1.66-3.45\r\n\t\t\t\tc0.17-0.35,0.52-0.57,0.9-0.57h7.86c0.38,0,0.73,0.22,0.9,0.57l1.67,3.45c0.07,0.14,0.1,0.28,0.1,0.43V375.89z\"></path></g></g></g>", 1))
  ]))
}
export default { render: render }